import { Button } from "MVVM/Components/Button";
import { useState } from "react";
import { Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

export const NoMoments = ({
  style = { marginTop: -25, minHeight: 500 },
  requestOnDemandMoments,
}: {
  style?: React.CSSProperties;
  requestOnDemandMoments?: () => void;
}) => {
  const [requestedOnDemand, setRequestedOnDemand] = useState(false);
  return (
    <Flex
      flexDirection={"column"}
      justifyContent={"start"}
      alignItems={"center"}
      style={style}
    >
      <DetectedMomentsImage
        src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/matchHistory/noMoments.webp`}
      />
      <Flex
        flexDirection={"column"}
        style={{ gap: 8, marginTop: -132 }}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Text style={{ marginBottom: 4 }} variant="text.headingSmall">
          {requestOnDemandMoments && !requestedOnDemand
            ? "Grab These Plays"
            : "No Moments Detected"}
        </Text>
        {requestOnDemandMoments && !requestedOnDemand && (
          <Text
            style={{ marginBottom: 12 }}
            variant="text.paragraphMedium"
            color="chalk"
            textAlign="center"
          >
            We haven't created all of the moments for this match yet. Click
            below to add them and they'll be ready shortly.
          </Text>
        )}

        {requestOnDemandMoments && !requestedOnDemand && (
          <Button
            size="small"
            flex={true}
            onClick={() => {
              setRequestedOnDemand(true);
              requestOnDemandMoments();
            }}
          >
            Get Moments
          </Button>
        )}
        {(!requestOnDemandMoments || requestedOnDemand) && (
          <Text
            style={{ marginBottom: 32, width: 400, textAlign: "center" }}
            variant="text.paragraphMedium"
            color="chalk"
          >
            Our algorithm has determined that none of these plays were good
            enough to clip. Get good scrub!
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

const DetectedMomentsImage = styled(Image)`
  width: 350px;
`;
